var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-down",style:({
  color: _vm.color
})},[(_vm.prefix)?_c('p',[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"block",style:({
    background: _vm.background,
  })},[_vm._v(_vm._s(_vm.minutes))]),_vm._v(" "),_c('span',[_vm._v(":")]),_vm._v(" "),_c('div',{staticClass:"block",style:({
    background: _vm.background,
  })},[_vm._v(_vm._s(_vm.seconds))])])}
var staticRenderFns = []

export { render, staticRenderFns }